import moment from "moment-timezone";
import React, { Component } from 'react';
import {
    injectIntl,
} from 'react-intl';
import SearchService from "../../../state/search/SearchService";
import GlobalHelper from "../../GlobalHelper.jsx";
import FilterToolbar from "../filters-menu/filterToolbar.component.jsx";

/**
 * Outdated version of the Search component used for legacy code support
 * See ./search.tsx for the updated component
 */
class Search extends Component {

    constructor(props, context) {
        super(props, context)

        this.state = {
            searchKeywords: props.searchKeywords || '',
            typeOfSearch: props.typeOfSearch,
            filtersApplied: [],
            object: props.object,
            fields: [],
            totals: [],
            filtersToUse: props.filtersToUse || {},
            savedFilterId: props.savedFilterId || '',
        }

        this.handleSearchChange = this.handleSearchChange.bind(this)
        this.handleClearFilters = this.handleClearFilters.bind(this)
        this.handleFiltersChange = this.handleFiltersChange.bind(this)
        this.refreshSearch = this.refreshSearch.bind(this)
        this.onChangeSavedFilter = this.onChangeSavedFilter.bind(this)

        let { fields, totals, filters } = SearchService.getTotalsFiltersAndFields(props)
        this.state.fields = fields
        this.state.totals = totals
        this.state.filtersApplied = filters
    }

    componentDidUpdate(prevProps) {
        const prevFiltersToUse = prevProps.filtersToUse || {}

        if (prevProps.savedFilterId !== this.props.savedFilterId) {
            this.setState({
                savedFilterId: this.props.savedFilterId
            })
        }
        if (prevProps.object.length !== this.props.object.length) {
            this.setState({
                object: this.props.object,
                filtersToUse: {},
                searchKeywords: "",
                savedFilterId: "",
            }, () => this.refreshSearch(true, true, true))
        }

        if (prevProps.searchKeywords !== this.props.searchKeywords) {
            this.setState({ searchKeywords: this.props.searchKeywords })
        }
        if (!this.isEqual(prevFiltersToUse, this.props.filtersToUse)) {
            this.setState({
                filtersToUse: this.props.filtersToUse
            }, () => this.refreshSearch(true, false, true))
        }
    }

    isEqual(pastFilters = {}, presentFilters = {}) {
        var isEqual = true
        if (Object.keys(pastFilters).length !== Object.keys(presentFilters).length) {
            isEqual = false;
        } else {
            if (pastFilters && Object.keys(pastFilters).length > 0) {
                Object.keys(pastFilters).forEach(elem => {
                    let pastElem = pastFilters[elem]
                    let presentElem = presentFilters[elem]
                    if ((presentElem && pastElem && JSON.stringify(pastElem.value) !== JSON.stringify(presentElem.value))) {
                        isEqual = false;
                    }
                })
            }
        }
        return isEqual;
    }

    componentDidMount() {
        !this.props.skipInitialChangeEvent && this.refreshSearch(true, true, true)
    }

    getFormattedDate(date) {
        return (moment(date)).format()
    }

    handleSearchChange(event) {
        const target = event.target;
        this.setState({
            searchKeywords: target.value,
        }, () => {
            this.refreshSearch(true, false, true)
        })
    }

    onChangeSavedFilter(filterId, filters) {
        if (filters) {
            this.setState({
                savedFilterId: filterId,
            }, () => {
                var filter = GlobalHelper.decodeSavedFilter(filters);
                this.handleFiltersChange(filter);
            })
        }
    }

    handleFiltersChange(newFiltersToUse) {
        this.setState({
            filtersToUse: newFiltersToUse,
        }, () => this.refreshSearch(true, true, true))
    }

    handleClearFilters() {
        this.setState({
            searchKeywords: '',
            filtersToUse: {},
            savedFilterId: ''
        }, () => {
            this.refreshSearch(true, true, true)
        })
    }

    refreshSearch(refreshTotal, refreshStatBox, savePrefs) {
        const data = SearchService.getSearchPostData(
            this.state.filtersToUse,
            this.state.typeOfSearch,
            this.state.filtersApplied,
            this.props.productType,
            this.state.object,
            this.state.totals,
            this.state.fields,
            this.state.searchKeywords
        )
        this.props.onChange(savePrefs, refreshTotal, refreshStatBox, data, this.state.filtersToUse, this.state.searchKeywords, this.state.savedFilterId);
    }

    render() {
        return (
            <div className="row ui-has-modules py-1">
                <div className="col-12 ui-module mb-0 pb-1">
                    <div className="row mb-0">
                        <div className="col-12 col-md-12">
                            <FilterToolbar
                                onKeyPress={e => {
                                    const code = e.keyCode || e.charCode
                                    if (code === 13) { return }
                                }}
                                minLength={0}
                                debounceTimeout={500}
                                autoComplete="off"
                                name="searchKeywords"
                                value={this.state.searchKeywords}
                                onChange={this.handleSearchChange}
                                id="searchKeywords"
                                type="text"
                                className="form-control"
                                childrenClass={this.props.childrenClass}
                                searchBarClass={this.props.searchBarClass}
                                onClearFilters={this.handleClearFilters}
                                filtersApplied={this.state.filtersApplied}
                                filtersToUse={this.state.filtersToUse}
                                placeholder={this.props.placeholder}
                                onChangeFilter={this.handleFiltersChange}
                                onChangeSavedFilter={this.onChangeSavedFilter}
                                listingType={this.state.typeOfSearch}
                                savedFilterId={this.state.savedFilterId}
                                hideFilters={this.props.hideFilters}
                                hideFilterDropdown={this.props.hideFilterDropdown}
                            >
                                {this.props.children}
                            </FilterToolbar>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default injectIntl(Search)



// WEBPACK FOOTER //
// ./src/common/search-filter/search/search.component.jsx